export interface LoginErrors {
  email?: string;
  password?: string;
}

export const validateLogin = (email: string, password: string): LoginErrors => {
  const errors: LoginErrors = {};

  if (!email.trim()) {
    errors.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(email)) {
    errors.email = "Invalid email format";
  }

  if (!password.trim()) {
    errors.password = "Password is required";
  } else if (password.length < 6) {
    errors.password = "Password must be at least 6 characters";
  }

  return errors;
};

export const validateEmail = (email: string): string => {
  let errors: string = "";

  if (!email.trim()) {
    errors = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(email)) {
    errors = "Invalid email format";
  }
  return errors;
};

export const validatePassword = (password: string): string => {
  let errors: string = "";

  if (!password.trim()) {
    errors = "Password is required";
  } else if (password.length < 6) {
    errors = "Password must be at least 6 characters";
  }

  return errors;
};
